module.exports = __webpack_public_path__ + "img/p8_3.017304be.png";